<template>
    <el-dialog
            :title="setId?'编辑病种信息':'新增病种信息'"
            :visible.sync="bingDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
            <el-form-item label="病种名称" prop="ill_id">
                <el-select v-model="accountForm.ill_id" filterable placeholder="请选择病种名称" style="width: 100%">
                    <el-option
                        v-for="item in bingList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="持续时间" prop="time_long">
                <el-input v-model="accountForm.time_long" placeholder="请输入持续时间"></el-input>
            </el-form-item>
            <el-form-item label="目前用药" prop="medicine_name">
                <el-input v-model="accountForm.medicine_name" placeholder="请输入目前用药"></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

import {getIllnessList, saveJuminIll} from "@/api/service";

export default {
    name: "bingDialog",
    props: {
        bingDialog: {
            type: Boolean,
            default: false
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {

        return {
            bingList:[],
            accountForm: {
                ill_id: [],
                time_long: '',
                medicine_name: '',
            },
            rules: {
                ill_id: [{required: true, message: '请选择病种名称', trigger: 'change'}],
                time_long: [{required: true, message: '请输入病种名称', trigger: 'blur'}],
                medicine_name: [{required: true, message: '请输入病种名称', trigger: 'blur'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },

    },
    created() {
        this.getBingList()
    },
    methods: {
        //  获取列表
        async getBingList() {
            let _list = await getIllnessList( 1, 999)
            this.bingList = _list.data
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await saveJuminIll(
                this.$route.params.id,
                this.accountForm.ill_id,
                this.accountForm.time_long,
                this.accountForm.medicine_name,
                this.setId ? this.setId : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        setItem() {
            this.accountForm = {
                ill_id: this.setItem.ill_id,
                time_long: this.setItem.time_long,
                medicine_name: this.setItem.medicine_name,
            };
        },
    }
}
</script>

<style scoped lang="scss">

</style>
